import request from '@/utils/seftRequest';

// 创建线索信息
export function createSfaLead(data) {
  return request('/ding/custService/createSfaLeadBsnl', {
    method: 'POST',
    body: data,
  });
}

// 查询线索信息
export function qrySfaLeadInfo(data) {
  return request('/ding/custService/qrySfaLeadInfoBsnl', {
    method: 'POST',
    body: data,
  });
}
